module.exports = __webpack_public_path__ + "static/deck-and-patio-contractors-547b82fc1b2fd82d0a3885ed10021930.jpg";